// AUTO-GENERATED by script-api-codegen
// DO NOT EDIT — regenerated on build start, HMR, and `bun run scripts/gen-script-api-codegen.ts`.

import type { AudioScriptApi as _M0 } from './modules/AudioScriptApi';
import type { CameraScriptApi as _M1 } from './modules/CameraScriptApi';
import type { EventsScriptApi as _M2 } from './modules/EventsScriptApi';
import type { GpuScriptApi as _M3 } from './modules/GpuScriptApi';
import type { InputScriptApi as _M4 } from './modules/InputScriptApi';
import type { LevelScriptApi as _M5 } from './modules/LevelScriptApi';
import type { PhysicsScriptApi as _M6 } from './modules/PhysicsScriptApi';
import type { SceneScriptApi as _M7 } from './modules/SceneScriptApi';
import type { UiScriptApi as _M8 } from './modules/UiScriptApi';
import type { VFXScriptApi as _M9 } from './modules/VFXScriptApi';

/** `audio` capability (tier: safe, v2) — backed by AudioScriptApi. */
export type IAudioApi = Pick<_M0, "playOneShot" | "play" | "stop" | "pause" | "resume" | "stopAll">;
/** `camera` capability (tier: safe, v1) — backed by CameraScriptApi. */
export type ICameraApi = Pick<_M1, "getOrthographicSize" | "setOrthographicSize" | "isActive" | "setActive" | "screenToWorld">;
/** `events` capability (tier: safe, v1) — backed by EventsScriptApi. */
export type IEventsApi = Pick<_M2, "emit" | "on">;
/** `gpu` capability (tier: system, v2) — backed by GpuScriptApi. */
export type IGpuApi = Pick<_M3, "isAvailable" | "loadKernel" | "createBuffer" | "createTexture">;
/** `input` capability (tier: safe, v1) — backed by InputScriptApi. */
export type IInputApi = Pick<_M4, "getInput" | "isInputPressed" | "isInputDown" | "isInputUp" | "getInputVector">;
/** `level` capability (tier: safe, v1) — backed by LevelScriptApi. */
export type ILevelApi = Pick<_M5, "load" | "preload" | "progress" | "unload" | "current">;
/** `physics` capability (tier: safe, v1) — backed by PhysicsScriptApi. */
export type IPhysicsApi = Pick<_M6, "raycast" | "overlapCircle" | "applyForce" | "applyImpulse" | "setVelocity" | "getVelocity">;
/** `scene` capability (tier: system, v1) — backed by SceneScriptApi. */
export type ISceneApi = Pick<_M7, "spawn" | "destroy" | "instantiate">;
/** `ui` capability (tier: safe, v1) — backed by UiScriptApi. */
export type IUiApi = Pick<_M8, "getScreen" | "pointerOverUI">;
/** `vfx` capability (tier: safe, v1) — backed by VFXScriptApi. */
export type IVfxApi = Pick<_M9, "play" | "stop" | "spawn" | "setLoop" | "isComplete" | "setVariable">;

/** The full engine-API surface. Optional members may be absent in a runtime. */
export interface EngineApi {
  readonly audio?: IAudioApi;
  readonly camera?: ICameraApi;
  readonly events?: IEventsApi;
  readonly gpu?: IGpuApi;
  readonly input?: IInputApi;
  readonly level?: ILevelApi;
  readonly physics?: IPhysicsApi;
  readonly scene?: ISceneApi;
  readonly ui?: IUiApi;
  readonly vfx?: IVfxApi;
}

/** The sandbox surface handed to user scripts — only `safe`-tier namespaces (§9). */
export interface SafeEngineApi {
  readonly audio?: IAudioApi;
  readonly camera?: ICameraApi;
  readonly events?: IEventsApi;
  readonly input?: IInputApi;
  readonly level?: ILevelApi;
  readonly physics?: IPhysicsApi;
  readonly ui?: IUiApi;
  readonly vfx?: IVfxApi;
}

/** Dense namespace -> slot id, for index-based resolution (§5 registry-wiring). */
export const EngineApiSlots = {
  audio: 0,
  camera: 1,
  events: 2,
  gpu: 3,
  input: 4,
  level: 5,
  physics: 6,
  scene: 7,
  ui: 8,
  vfx: 9,
} as const;

export const ENGINE_API_NAMESPACES = ["audio", "camera", "events", "gpu", "input", "level", "physics", "scene", "ui", "vfx"] as const;
export type EngineApiNamespace = (typeof ENGINE_API_NAMESPACES)[number];

/** Per-namespace metadata for runtime introspection (tier filter, version check). */
export const ENGINE_API_MODULES: ReadonlyArray<{ namespace: EngineApiNamespace; tier: 'safe' | 'system' | 'editor'; version: number }> = [
  { namespace: "audio", tier: "safe", version: 2 },
  { namespace: "camera", tier: "safe", version: 1 },
  { namespace: "events", tier: "safe", version: 1 },
  { namespace: "gpu", tier: "system", version: 2 },
  { namespace: "input", tier: "safe", version: 1 },
  { namespace: "level", tier: "safe", version: 1 },
  { namespace: "physics", tier: "safe", version: 1 },
  { namespace: "scene", tier: "system", version: 1 },
  { namespace: "ui", tier: "safe", version: 1 },
  { namespace: "vfx", tier: "safe", version: 1 },
];

/** Aggregate engine-API surface version (major.minor), §10. */
export const ENGINE_API_VERSION = { major: 0, minor: 1 } as const;

/** ABI hash of the engine-API IR; asserted across language projections (§10). */
export const ENGINE_API_ABI_HASH = "86840190";
